import { inventoryApi, } from '@sellsen/generated-sources';
import { ProductHistoryControllerApi, } from '@sellsen/generated-sources';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { USER_QUERY_KEYS } from '../user';
const productHistoryApi = new ProductHistoryControllerApi(inventoryApi.configuration);
const QUERY_KEYS = {
    allInventoryProducts: ['inventory-products'],
    getInventoryProducts: (params) => [
        ...QUERY_KEYS.allInventoryProducts,
        params,
    ],
    getInventoryProductDetail: (params) => [
        ...QUERY_KEYS.allInventoryProducts,
        'detail',
        params,
    ],
    getInventoryProductHistory: (params) => [
        ...QUERY_KEYS.allInventoryProducts,
        'history',
        params,
    ],
};
export const useGetInventoryProductsQuery = (params) => {
    return useQuery({
        queryKey: QUERY_KEYS.getInventoryProducts(params),
        queryFn: () => {
            return inventoryApi.getInventoryProducts(params);
        },
    });
};
export const useDeleteInventoriesMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (params) => inventoryApi.deleteInventories(params),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: QUERY_KEYS.allInventoryProducts,
            });
            // Katalog kotası = envanter + ürün havuzu; silme kota şeridini anında güncellemeli.
            queryClient.invalidateQueries({ queryKey: USER_QUERY_KEYS.all });
        },
    });
};
// Elle silme onayından önce: seçimde son N günde satış almış ürünler (hiçbir şey silmez).
export const usePreviewInventoryDeleteMutation = () => {
    return useMutation({
        mutationFn: (params) => inventoryApi.previewInventoryDelete(params),
    });
};
export const useGetInventoryProductDetailQuery = (params, enabled = true) => {
    return useQuery({
        queryKey: QUERY_KEYS.getInventoryProductDetail(params),
        queryFn: () => inventoryApi.getInventoryProductDetail(params),
        enabled,
    });
};
export const useGetInventoryProductHistoryQuery = (params, enabled = true) => {
    return useQuery({
        queryKey: QUERY_KEYS.getInventoryProductHistory(params),
        queryFn: () => productHistoryApi.getAllHistoryByInventoryId(params),
        enabled,
    });
};
